import $ from 'jquery';
import ProgressBar from 'progressbar.js';

function setBars () {
    var bar1 = new ProgressBar.Circle(stat1, {
        color: '#00efe8',
        strokeWidth: 5.23,
        trailWidth: 0,
        easing: 'easeInOut',
        duration: 1400,
        text: {
            autoStyleContainer: false,
            style: null
        },
        from: { color: '#a093ff'},
        to: { color: '#00efe8'},
        // Set default step function for all animate calls
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);

            var value = Math.round(circle.value() * 100);
            if (value === 0) {
                circle.setText('');
            } else {
                circle.setText(value + '%');
            }

            $('#stat1 .stats-circle__value').addClass('-active');

        }
    });
    var bar2 = new ProgressBar.Circle(stat2, {
        color: '#00efe8',
        strokeWidth: 5.84,
        trailWidth: 0,
        easing: 'easeInOut',
        duration: 1400,
        text: {
            autoStyleContainer: false,
            style: null
        },
        from: { color: '#a093ff'},
        to: { color: '#00efe8'},
        // Set default step function for all animate calls
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);

            var value = Math.round(circle.value() * 100);
            if (value === 0) {
                circle.setText('');
            } else {
                circle.setText(value + '%');
            }

            $('#stat2 .stats-circle__value').addClass('-active');

        }
    });
    var bar3 = new ProgressBar.Circle(stat3, {
        color: '#00efe8',
        strokeWidth: 6.69,
        trailWidth: 0,
        easing: 'easeInOut',
        duration: 1400,
        text: {
            autoStyleContainer: false,
            style: null
        },
        from: { color: '#a093ff'},
        to: { color: '#00efe8'},
        // Set default step function for all animate calls
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);

            var value = Math.round(circle.value() * 100);
            if (value === 0) {
                circle.setText('');
            } else {
                circle.setText(value + '%');
            }

            $('#stat3 .stats-circle__value').addClass('-active');

        }
    });
    var bar4 = new ProgressBar.Circle(stat4, {
        color: '#00efe8',
        strokeWidth: 7.72,
        trailWidth: 0,
        easing: 'easeInOut',
        duration: 1400,
        text: {
            autoStyleContainer: false,
            style: null
        },
        from: { color: '#a093ff'},
        to: { color: '#00efe8'},
        // Set default step function for all animate calls
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);

            var value = Math.round(circle.value() * 100);
            if (value === 0) {
                circle.setText('');
            } else {
                circle.setText(value + '%');
            }

            $('#stat4 .stats-circle__value').addClass('-active');

        }
    });

    function checkActiveStat() {
        $('.stats-circle__value').removeClass('-active');
        const sections = ['1', '2', '3', '4'];
        const bars = [bar1, bar2, bar3, bar4];
        const stats = ['#stat1', '#stat2', '#stat3', '#stat4'];
        for ( var i = 0; i < sections.length; i++ )
        {
            if ( document.getElementById('stat' + sections[i] + '-trigger').checked )
            {
                return bars[i].animate($(stats[i]).attr('data-par') / $(stats[i]).attr('data-denom'));
            }
        }
    }

    $('.stats').on('click', function () {
        bar1.set(0);
        bar2.set(0);
        bar3.set(0);
        bar4.set(0);

        checkActiveStat();
    });

    checkActiveStat();
}

function init() {
    if ($('.stats-circle').length > 0) {
        setBars();
    }
}

export { init };




// WEBPACK FOOTER //
// ./src/_app/components/stats-circle.js